var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "room-content" },
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          staticClass: "form-box",
          attrs: { model: _vm.ruleForm, "label-width": "140px" },
        },
        [
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("setting.headportrait") + "：",
                prop: "business_license",
              },
            },
            [
              _c(
                "el-row",
                { staticClass: "upload-content" },
                [
                  _c(
                    "el-col",
                    { staticClass: "left", attrs: { span: 8 } },
                    [
                      !_vm.ruleForm.avatar
                        ? _c(
                            "el-upload",
                            {
                              attrs: {
                                "auto-upload": true,
                                headers: _vm.myHeaders,
                                "http-request": _vm.uploadServerLog,
                                "show-file-list": false,
                                action: "##",
                                "list-type": "picture-card",
                              },
                            },
                            [_c("i", { staticClass: "el-icon-plus" })]
                          )
                        : _c(
                            "div",
                            {
                              staticClass:
                                "el-upload-list el-upload-list--picture-card",
                            },
                            [
                              _c("img", {
                                staticClass: "el-upload-list__item-thumbnail",
                                attrs: { src: _vm.ruleForm.avatar, alt: "" },
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "el-upload-list__item-actions" },
                                [
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "el-upload-list__item-delete",
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "el-icon-delete",
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleRemove()
                                          },
                                        },
                                      }),
                                    ]
                                  ),
                                ]
                              ),
                            ]
                          ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("el-col", { staticClass: "right", attrs: { span: 8 } }, [
                    _c("p", [_vm._v("建议图片分辨率80*80且大小不能超过2M,")]),
                    _vm._v(" "),
                    _c("p", [_vm._v("支持上传jpg、jpeg、gif、png格式的图片")]),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("setting.name") + "：",
                prop: "enterprise_name",
              },
            },
            [
              _c("el-input", {
                attrs: {
                  placeholder: _vm.$t("setting.title"),
                  clearable: "",
                  size: "small",
                },
                model: {
                  value: _vm.ruleForm.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.ruleForm, "name", $$v)
                  },
                  expression: "ruleForm.name",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("setting.userid") + "：",
                prop: "enterprise_name",
              },
            },
            [
              _c(
                "div",
                { staticClass: "flex-item" },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: _vm.$t("setting.useridtitle"),
                      disabled: "",
                      size: "small",
                    },
                    model: {
                      value: _vm.ruleForm.uid,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "uid", $$v)
                      },
                      expression: "ruleForm.uid",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticClass: "btns copy-data",
                      attrs: {
                        "data-clipboard-text": _vm.ruleForm.uid,
                        type: "text",
                      },
                      on: { click: _vm.copy },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("setting.copy")) +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("setting.phone") + "：",
                prop: "enterprise_name",
              },
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isEditPhone,
                      expression: "isEditPhone",
                    },
                  ],
                  staticClass: "flex-item",
                },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: _vm.$t("setting.phonetitle"),
                      disabled: "",
                      size: "small",
                    },
                    model: {
                      value: _vm.ruleForm.phone,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "phone", $$v)
                      },
                      expression: "ruleForm.phone",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "el-link",
                    {
                      staticClass: "btns",
                      attrs: { underline: false, type: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.isEditPhone = false
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("setting.changephone")) +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isEditPhone === false,
                      expression: "isEditPhone === false",
                    },
                  ],
                  staticClass: "flex-item",
                },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: _vm.$t("setting.phonetitle"),
                      size: "small",
                    },
                    model: {
                      value: _vm.newPhone,
                      callback: function ($$v) {
                        _vm.newPhone = $$v
                      },
                      expression: "newPhone",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticClass: "button ml10",
                      attrs: {
                        disabled: _vm.disabled,
                        size: "small",
                        type: "primary",
                      },
                      on: { click: _vm.getCode },
                    },
                    [_vm._v(_vm._s(_vm.text))]
                  ),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isEditPhone === false,
                  expression: "isEditPhone === false",
                },
              ],
              attrs: {
                label: _vm.$t("login.code") + "：",
                prop: "enterprise_name",
              },
            },
            [
              _c("el-input", {
                attrs: {
                  placeholder: _vm.$t("login.codetitle"),
                  size: "small",
                  type: "text",
                },
                model: {
                  value: _vm.verification_code,
                  callback: function ($$v) {
                    _vm.verification_code = $$v
                  },
                  expression: "verification_code",
                },
              }),
              _vm._v(" "),
              _c(
                "el-link",
                {
                  staticClass: "btns",
                  attrs: { underline: false, type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.isEditPhone = true
                    },
                  },
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.$t("public.cancel")) + "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("login.password") + "：",
                prop: "password",
              },
            },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isEditPassword,
                      expression: "isEditPassword",
                    },
                  ],
                  staticClass: "flex-item",
                },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: _vm.$t("login.title2"),
                      "auto-complete": "on",
                      disabled: "",
                      size: "small",
                      type: "password",
                    },
                    model: {
                      value: _vm.ruleForm.password,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "password", $$v)
                      },
                      expression: "ruleForm.password",
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "el-link",
                    {
                      staticClass: "btns",
                      attrs: { underline: false, type: "primary" },
                      on: { click: _vm.replacePwd },
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.$t("login.changepassword")) +
                          "\n        "
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.isEditPassword === false,
                      expression: "isEditPassword === false",
                    },
                  ],
                  staticClass: "flex-item",
                  attrs: { prop: "newPassword" },
                },
                [
                  _c("el-input", {
                    attrs: {
                      placeholder: _vm.$t("login.title2"),
                      "auto-complete": "on",
                      clearable: "",
                      size: "small",
                      type: "password",
                    },
                    on: { blur: _vm.regularFn },
                    model: {
                      value: _vm.newPassword,
                      callback: function ($$v) {
                        _vm.newPassword = $$v
                      },
                      expression: "newPassword",
                    },
                  }),
                ],
                1
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isEditPassword === false,
                  expression: "isEditPassword === false",
                },
              ],
              attrs: {
                label: _vm.$t("login.confirmpassword") + "：",
                prop: "enterprise_name",
              },
            },
            [
              _c("el-input", {
                attrs: {
                  placeholder: _vm.$t("login.title2"),
                  clearable: "",
                  size: "small",
                  type: "password",
                },
                model: {
                  value: _vm.password_confirm,
                  callback: function ($$v) {
                    _vm.password_confirm = $$v
                  },
                  expression: "password_confirm",
                },
              }),
              _vm._v(" "),
              _c(
                "el-link",
                {
                  staticClass: "btns",
                  attrs: { underline: false, type: "primary" },
                  on: { click: _vm.cancelPwd },
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.$t("public.cancel")) + "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              attrs: {
                label: _vm.$t("setting.mailbox") + "：",
                prop: "enterprise_name",
              },
            },
            [
              _c("el-input", {
                attrs: {
                  placeholder: _vm.$t("setting.mailboxtitle"),
                  clearable: "",
                  size: "small",
                },
                model: {
                  value: _vm.ruleForm.email,
                  callback: function ($$v) {
                    _vm.$set(_vm.ruleForm, "email", $$v)
                  },
                  expression: "ruleForm.email",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "room-footer btn-shadow" },
        [
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.cancel } },
            [_vm._v(_vm._s(_vm.$t("public.cancel")))]
          ),
          _vm._v(" "),
          _c(
            "el-button",
            {
              attrs: { size: "small", type: "primary" },
              on: { click: _vm.preserve },
            },
            [_vm._v("\n      " + _vm._s(_vm.$t("public.save")) + "\n    ")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }